import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'dueDateClass', standalone: true, pure: true})
export class DueDateClassPipe implements PipeTransform {
  transform(date: Date | string | null | undefined): string {
    if (!date) return '';

    const due = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    const diffDays = Math.round((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'text-red-500 font-medium';
    if (diffDays <= 2) return 'text-orange-500 font-medium';
    if (diffDays <= 7) return 'text-amber-500';
    return 'text-[var(--p-surface-400)]';
  }
}
